import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { EnvironmentService } from '../../_services/environment.service';

@Component({
    selector: 'app-EServicesAccountUpgrades',
    templateUrl: './EServicesAccountUpgrades.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class EServicesAccountUpgradesComponent {
  private readonly envService = inject(EnvironmentService);
  // Same targets as the home page E-Services banner
  links = { loginUrl: '/login?returnUrl=%2F', registerUrl: this.envService.getSsoRegisterUrl() };
}
